<template>
  <custom-dialog title="Move To Folder">
    <template>
      <el-select
        v-model="select"
        filterable
        placeholder="Please choose a folder"
      >
        <el-option
          v-for="opt in options"
          :key="opt.value"
          :label="opt.label"
          :value="opt.value"
        >
          <el-row
            type="flex"
            justify="space-between"
            :gutter="20"
            :class="select !== opt.value ? 'gray' : 'pink'"
          >
            <el-col :span="1">
              <i class="fas" :class="opt.value ? 'fa-folder' : 'fa-home'"></i>
            </el-col>
            <el-col>
              <span>{{ opt.label }}</span>
            </el-col>
          </el-row>
        </el-option>
      </el-select>
    </template>
    <template #footer-btn>
      <el-button
        class="btn btn-form btn-blue btn-footer"
        @click="submit()"
        :disabled="select === row.folder"
        >Submit</el-button
      >
    </template>
  </custom-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import CustomDialog from "@/components/base/customDialog";
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      select: "",
    };
  },
  components: {
    CustomDialog,
  },
  computed: {
    ...mapState({
      visible: (state) => state.isDialogVisible,
      folders: (state) => state.creativeFolder.folders,
    }),
    options() {
      let home = [
        {
          label: "My Creatives",
          value: "",
        },
      ];
      let folders = _.map(this.folders, (folder) => {
        return {
          label: folder.name,
          value: folder._id,
        };
      });
      return _.concat(home, folders);
    },
  },
  created() {
    this.initData();
  },
  watch: {
    visible(newVisible) {
      if (newVisible) this.initData();
    },
  },
  methods: {
    initData() {
      this.select = "";
      if (this.row.folder) this.setData();
    },
    setData() {
      this.select = this.row.folder;
    },
    async submit() {
      let setObj = {
        folder: this.select,
      };
      if (this.row.id) {
        await store.dispatch("creative/patchCreativeById", {
          id: this.row.id,
          setObj: setObj,
        });
      } else {
        await store.dispatch("creative/patchCreatives", {
          setObj: setObj,
        });
      }

      this.$message({ message: "Success!", type: "success" });
      store.commit("setDialogVisible", false);
    },
  },
};
</script>
